import { render, staticRenderFns } from "./generatedinvoices.vue?vue&type=template&id=1cf52744"
import script from "./generatedinvoices.vue?vue&type=script&lang=js"
export * from "./generatedinvoices.vue?vue&type=script&lang=js"
import style0 from "./generatedinvoices.vue?vue&type=style&index=0&id=1cf52744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports